import { Page } from '@/components';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  HomesOfferingsReportButtonPanel,
  ProjectHomePersonalizationPanel,
  SearchProjectHomeInput,
  useProjectHomeSelectedState,
} from '@/views';
import { useGetProjectQuery } from '@/redux';
import { Col, Row, Space } from 'antd';
import styles from './ProjectHomePersonalizationPage.module.scss';
import { FormatPainterOutlined } from '@ant-design/icons';
import { DeadlineOverrideButton } from '@/views/Projects.Homes.Details';

export function ProjectHomePersonalizationPage() {
  const { t } = useTranslation();
  const { id } = useParams<'id'>();
  const selectedState = useProjectHomeSelectedState();
  const { homeId: selectedHomeId } = selectedState;

  const { data: project } = useGetProjectQuery({ id: id! }, { skip: !id });
  const { communityId } = project ?? {};

  return (
    <Page.Card
      title={
        <Row align="middle">
          <Col>{t('personalization.homeTitle')}</Col>
        </Row>
      }
      actions={
        <>
          <Space size="large">
            {communityId && (
              <SearchProjectHomeInput
                communityId={communityId}
                projectId={id}
                showResidentNames
                className={styles.homeInput}
                {...selectedState}
              />
            )}
            {selectedHomeId && project && (
              <DeadlineOverrideButton homeId={selectedHomeId} projectId={id!} />
            )}
          </Space>

          {selectedHomeId && project && (
            <HomesOfferingsReportButtonPanel
              projectId={project.id}
              homeId={selectedHomeId}
            />
          )}
        </>
      }
      icon={<FormatPainterOutlined style={{ fontSize: '20px' }} />}
      color="#EFAC4E"
      className={styles.card}
    >
      {id && (
        <ProjectHomePersonalizationPanel
          projectId={id!}
          selectedHomeId={selectedHomeId}
        />
      )}
    </Page.Card>
  );
}
